import React from 'react'
import '../styles/Footer.css'

const Footer = () => {
  return (
    <div className="footer-component">
      <footer>
        &copy; {new Date().getFullYear()} Reachpersona.com. All Rights Reserved.
      </footer>
    </div>
  )
}

export default Footer
